import { BASE_URL } from "../config/config";

// Fetch the latest channels from the API
export const fetchBlogPosts = async () => {
    try {
        const response = await fetch(`${BASE_URL}/blogs`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching latest channels:', error);
        throw error;
    }
};
